// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    attendance_my_status: 'Mirando tu jornada',
    attendance_clock_in: 'Fichando tu entrada',
    attendance_clock_out: 'Fichando tu salida',
    attendance_who_is_working: 'Mirando quién está trabajando',
    attendance_find_worker: 'Buscando a la persona',
    attendance_my_hours_summary: 'Sumando tus horas',
    attendance_hours_summary: 'Sumando las horas del equipo',
  },
  ca: {
    attendance_my_status: 'Mirant la teva jornada',
    attendance_clock_in: 'Fitxant la teva entrada',
    attendance_clock_out: 'Fitxant la teva sortida',
    attendance_who_is_working: 'Mirant qui està treballant',
    attendance_find_worker: 'Buscant la persona',
    attendance_my_hours_summary: 'Sumant les teves hores',
    attendance_hours_summary: 'Sumant les hores de l’equip',
  },
  en: {
    attendance_my_status: 'Checking your day',
    attendance_clock_in: 'Clocking you in',
    attendance_clock_out: 'Clocking you out',
    attendance_who_is_working: 'Seeing who is working',
    attendance_find_worker: 'Finding the person',
    attendance_my_hours_summary: 'Adding up your hours',
    attendance_hours_summary: 'Adding up the team\'s hours',
  },
  fr: {
    attendance_my_status: 'Consultation de votre journée',
    attendance_clock_in: 'Pointage de votre arrivée',
    attendance_clock_out: 'Pointage de votre départ',
    attendance_who_is_working: 'Qui est en train de travailler',
    attendance_find_worker: 'Recherche de la personne',
    attendance_my_hours_summary: 'Total de vos heures',
    attendance_hours_summary: 'Total des heures de l’équipe',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
